









import {Dropdown} from 'bootstrap';
import {Component, Prop, Vue} from 'vue-property-decorator';
import htmlFiles from './parameterHelpHtml';

@Component
export default class ParameterHelp extends Vue {
    @Prop({type: String, required: true})
    public readonly name: keyof typeof htmlFiles.common;

    @Prop({type: String, required: true})
    public readonly estateType: keyof typeof htmlFiles;

    protected content: string | null;

    private dropdown: Dropdown;

    public created() {
        this.content = htmlFiles[this.estateType][this.name] || htmlFiles.common[this.name];
    }

    public mounted(): void {
        if (! ('button' in this.$refs)) {
            return;
        }

        this.dropdown = new Dropdown(this.$refs.button as HTMLElement);
    }
}
